import React from "react";
import { Grid, Breadcrumbs, Link, Typography, makeStyles, Theme, createStyles } from "@material-ui/core";
import { NavigateNext as NavigateNextIcon } from "@material-ui/icons";
import { navigate } from "@reach/router";
import { useStepData } from "../context";
import { availableSteps as stepsNames } from "..";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    breadcrumbLink: {
      cursor: "pointer",
      color: theme.palette.text.primary,
    },
    underline: {
      textDecoration: "underline",
    },
    disabledBreadcrumb: {
      pointerEvents: "none",
      color: theme.palette.text.disabled,
      cursor: "default",
    },
  }));

interface BreadcrumbNavigatorProps {
  children: React.ReactNode;
}

const BreadcrumbNavigator: React.FC<BreadcrumbNavigatorProps> = ({ children }) => {
  const { viewer, stepName, setStepName } = useStepData();
  const currentStepIndex = stepsNames.findIndex((step) => stepName === step);
  const classes = useStyles();

  const handleBreadcrumbClick = (index: number) => {
    if (index < currentStepIndex) {
      setStepName(stepsNames[index]);
      navigate((stepsNames[index] ?? "Unknown").toLowerCase());
    }
  };

  // Navigate to the first step if current url is settings/imports not settings/imports/upload
  React.useEffect(() => {
    if (window.location.pathname === "/dash/manager/settings/imports") {
      navigate("/dash/manager/settings/imports/upload", { replace: true });
    }
  }, []);

  if (!viewer) return null;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          {stepsNames.map((step, index) => {
            if (index === currentStepIndex) {
              return (
                <Typography key={index} color="primary" className={classes.underline}>
                  {step}
                </Typography>
              );
            }
            return (
              <Link
                key={index}
                color="inherit"
                onClick={() => handleBreadcrumbClick(index)}
                className={index < currentStepIndex ? classes.breadcrumbLink : classes.disabledBreadcrumb}
              >
                {step}
              </Link>
            );
          })}
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12}>
        {children}
      </Grid>
    </Grid>
  );
};

export default BreadcrumbNavigator;
